import { IGetAllResponse, IGetOneResponse } from '../Utilis/Types/Generic';
import { ApiService } from './ApiService';

export class DocumentService extends ApiService {
  static pathName = 'document';

  static getUserDocuments = (): Promise<IGetAllResponse<any>> => {
    return this.get(`${this.pathName}`);
  };

  static getAllUserDocuments = (): Promise<IGetAllResponse<any>> => {
    return this.get(`${this.pathName}/all`);
  };

  static getUserDocumentsAdmin = (
    id: string
  ): Promise<IGetAllResponse<any>> => {
    return this.get(`${this.pathName}/user/${id}`);
  };

  static addDocument = (body: {
    id: string;
    file: File;
  }): Promise<IGetAllResponse<any>> => {
    const formData = new FormData();
    formData.append('file', body.file);
    formData.append('requiredDocumentId', body.id);
    return this.post(`${this.pathName}/upload`, formData, undefined, {
      'Content-Type': 'multipart/form-data',
    });
  };

  static getAdditionalDocuments = (): Promise<IGetAllResponse<any>> => {
    return this.get(`${this.pathName}/other`);
  };

  static getAdditionalDocumentsAdmin = (
    id: string
  ): Promise<IGetAllResponse<any>> => {
    return this.get(`${this.pathName}/other/user/${id}`);
  };

  static uploadRequiredDocument = (
    name: string,
    strategyId: string | null,
    userId: string
  ): Promise<IGetOneResponse<any>> => {
    return this.post(`${this.pathName}/required`, { name, strategyId, userId });
  };

  static deleteDocument = (id: string) => {
    return this.delete(`${this.pathName}/${id}`);
  };

  static deleteRequiredDocument = (id: string) => {
    return this.delete(`${this.pathName}/required/${id}`);
  };
}
